import clsx from 'clsx';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

const cx = (...classes: (string | false | null | undefined)[]) => twMerge(clsx(classes));

type BoxRootProps = React.HTMLAttributes<HTMLDivElement> & {
	clickable?: boolean;
	active?: boolean;
};

const BoxRoot = forwardRef<HTMLDivElement, BoxRootProps>(
	({ clickable, active, className, ...props }, ref) => {
		return (
			<div
				ref={ref}
				className={cx(
					'card flex flex-col justify-around gap-3 w-full h-full relative transition-all ease-in-out duration-400 overflow-x-hidden min-h-40',
					clickable && 'cursor-pointer',
					active && 'border-cuaternary',
					className,
				)}
				{...props}
			/>
		);
	},
);
BoxRoot.displayName = 'BoxRoot';

export default BoxRoot;
